/**
 * Styled Components - Created by david on 08/05/18.
 */
import styled from 'styled-components'

export const Container = styled.div``

export const ContainerReset = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px;
`

export const Buttons = styled.div`
  padding: 16px;
`

export const Footer = styled.div`
  padding: 0px 16px;
`

export const ButtonWrapper = styled.div`
  margin-bottom: 16px;

  .ant-btn-lg {
    width: 100%;
  }
`

export const Text = styled.div`
  color: #5f6062;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
`

export const ButtonUpload = styled.div`
  color: #5f6062;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  padding: 8px;
  cursor: pointer;
`

export const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #eff2f4;
`

export const Preview = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background-color: #eff2f4;
`

export const Label = styled.div`
  color: #5f6062;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  padding: 8px;
  padding-bottom: 18px;
  cursor: pointer;
`

export const FileContainer = styled.div`
  padding: 8px;
  border: solid;
  border-width: 1px;
  border-color: #fafafa;
  margin-bottom: 16px;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
export const DesignContainer = styled.div`
  padding: 16px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/DesignerTool/DesignCenterCustomize/UploadTab/styledComponents.tsx